import {objectPatch} from '../../../../../lib/helpers';
import {SelectItem, SelectQuestionModel} from '../models';

export interface SelectState {
  // id of slot
  readonly selected: number | null;
  readonly checked: boolean;
  readonly checkCount: number;
}

export interface SelectStates {
  readonly [index: string]: SelectState
}

export interface SelectQuestionState {
  readonly states: SelectStates;
}

export interface SelectOption {
  readonly value: number,
  readonly label: string
}

/******************************************************************************/

export function positionToItemId(paragraph: number, index: number) {
  return paragraph.toString(10) + '/' + index.toString(10);
}

/******************************************************************************/

export function selectItemsById(model: SelectQuestionModel): ReadonlyMap<string, SelectItem> {
  const result = new Map<string, SelectItem>();

  for (let paragraphIndex = 0; paragraphIndex < model.paragraphs.length; paragraphIndex++) {
    const paragraph = model.paragraphs[paragraphIndex];
    for (let index = 0; index < paragraph.items.length; index++) {
      let item = paragraph.items[index];
      if (item.type !== 'select')
        continue;
      const itemId = positionToItemId(paragraphIndex,index);
      result.set(itemId, item);
    }
  }

  return result;
}

/******************************************************************************/
export function selectOptionsById(itemsById: ReadonlyMap<string, SelectItem>):
  ReadonlyMap<string, readonly SelectOption[]> {
  const result = new Map<string, readonly SelectOption[]>();
  for (let [itemId, item] of itemsById.entries()) {
    const options: SelectOption[] = [];
    for (let i = 0; i < item.choices.length; i++)
      options.push({value: i, label: item.choices[i].label});
    result.set(itemId, options);
  }

  return result;
}

/******************************************************************************/

export function checkAllItems(state: SelectQuestionState): SelectQuestionState {
  let result: { [index: string]: SelectState } = {};
  for (let [itemId, selectState] of Object.entries(state.states)) {
    if (selectState.checked || selectState.selected === null)
      result[itemId] = selectState;
    else
      result[itemId] = {
        selected: selectState.selected,
        checked: true,
        checkCount: selectState.checkCount + 1
      };
  }
  return {states: result};
}

/******************************************************************************/
export function setSelected(state: SelectQuestionState,
                            selectId: string,
                            selected: number | null): SelectQuestionState {
  const states = state.states;
  const oldState = states[selectId];
  const newState: SelectState = {
    selected: selected,
    checked: false,
    checkCount: oldState.checkCount
  };
  const newStates = objectPatch(states, selectId, newState);
  return {states: newStates};
}
